function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2605",
  "data-name": "Group 2605",
  transform: "translate(-219.879 -308.699)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_564",
  "data-name": "Line 564",
  x1: 56.78,
  y2: 56.78,
  transform: "translate(222 310.82)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "_0XDDse",
  "data-name": "0XDDse",
  transform: "translate(233.89 413.408)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2575",
  "data-name": "Group 2575",
  transform: "translate(-1.478 -101.099)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3683",
  "data-name": "Path 3683",
  d: "M.776-63.74c-2.654-6.432-.593-12.1,2.545-17.591A115.436,115.436,0,0,1,16.809-99.705c1.526-1.752,3.365-1.877,4.79-.236a112.7,112.7,0,0,1,15.291,21.6c6.781,13-3.875,27.123-16.377,27.649a5.8,5.8,0,0,0-2.03.5C9.849-46.4.479-51.234-1.252-60.393-1.741-62.983-1.591-63.259.776-63.74Zm21.5,10.871c.836-.177,1.331-.265,1.818-.386,9.588-2.389,16.37-13.791,11.12-24.076-3.975-7.788-9.3-14.579-14.959-21.158-.732-.852-1.331-.7-1.977.087-1.3,1.58-2.661,3.114-3.939,4.712C10.052-88.329,5.974-82.834,3.085-76.552a15.45,15.45,0,0,0-.717,11.663,1.5,1.5,0,0,0,1.812,1.263A14.235,14.235,0,0,1,11.417-62.4c.543.248,1.065.543,1.67.853.107-.612.169-1.034.255-1.451.894-4.311,3.936-7.308,6.543-10.557.172-.214,1.12-.131,1.427.136a13.771,13.771,0,0,1,4.9,12.33A13.807,13.807,0,0,1,22.275-52.868Zm-2.995-.207c5.823-3.55,6.905-13.508,1.95-17.457ZM15.749-51.32.827-60.545C1.774-53.832,8.866-49.412,15.749-51.32Zm3.343-17.961c-4.8,5.114-5.481,11.877-1.716,15.526C17.941-58.867,18.494-63.874,19.092-69.281Zm-5.14,14.512c-.916-1.76-.051-4.163-2.319-5.353a13.734,13.734,0,0,0-8.552-1.363Z",
  transform: "translate(1.478 101.099)",
  fill: "#a64daa",
  stroke: "#a64daa",
  strokeWidth: 1
}))));

var SvgParabenfreeIcon = function SvgParabenfreeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61.023,
    height: 61.023,
    viewBox: "0 0 61.023 61.023",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgParabenfreeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/parabenfree-icon.83ed6006.svg";
export { ForwardRef as ReactComponent };